module.exports = __webpack_public_path__ + "img/p67-beijing-2016.0b335bdc.jpg";